const getTooltipStyles = (isError, followMouse, tooltipOffset, place) => {
  const getFontFamily = () => {
    let fontFamily = "Helvetica Neue";
    if (typeof window !== "undefined") {
      const stylesContainer = document.querySelector(`[data-hook=root-editor]`) || document.body;
      const styles = window.getComputedStyle(stylesContainer);
      fontFamily = styles.getPropertyValue("--ricos-settings-text-font-family") || "Helvetica Neue";
    }
    return fontFamily;
  };
  return {
    style: {
      background: isError ? "#F64D43" : "rgb(0,0,0)",
      color: "white",
      padding: "8px 12px",
      fontFamily: getFontFamily(),
      border: "solid 1px rgba(255,255,255,0.38)",
      maxWidth: "180px",
      position: followMouse ? "relative" : "absolute",
      fontSize: "14px",
      marginTop: place === "top" && tooltipOffset ? Math.abs(tooltipOffset.y) : tooltipOffset == null ? void 0 : tooltipOffset.y,
      pointerEvents: "none",
      transition: "none",
      fontWeight: "300",
      zIndex: 1e6
    },
    arrowStyle: {
      color: isError ? "#F64D43" : "rgb(0,0,0)",
      borderColor: "rgba(255,255,255,0.38)",
      pointerEvents: "none",
      transition: "none"
    }
  };
};

export { getTooltipStyles };
//# sourceMappingURL=tooltipStyles.js.map
